import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSustainability = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 21a7.59 7.59 0 0 1-1.662-.188 11.216 11.216 0 0 1-1.713-.537c.2-2.017.783-3.9 1.75-5.65A17.173 17.173 0 0 1 13.35 10a15.78 15.78 0 0 0-4.762 3.7 13.064 13.064 0 0 0-2.813 5.25 1.751 1.751 0 0 1-.188-.162L5.4 18.6a8.212 8.212 0 0 1-1.788-2.625A7.697 7.697 0 0 1 3 12.95c0-1.133.225-2.217.675-3.25A8.858 8.858 0 0 1 5.55 6.95C6.717 5.783 8.162 4.967 9.887 4.5c1.726-.467 4.055-.633 6.988-.5.433.017.833.113 1.2.288s.692.404.975.687c.283.283.508.613.675.988.167.375.267.779.3 1.212.1 3-.075 5.342-.525 7.025-.45 1.683-1.25 3.1-2.4 4.25a8.905 8.905 0 0 1-2.738 1.887A7.682 7.682 0 0 1 11.25 21z",
		fill: "currentColor"
	})
});
export default SvgSustainability;
